import { createRoute } from '@tanstack/react-router';
import { lazyPage } from '../common';
import { siteRoute } from '../layouts';

const pages = () => import('./discounts-pages');
const discountsComp = lazyPage(pages, 'DiscountsListHost');
const discountCreateComp = lazyPage(pages, 'DiscountCreateHost');
const discountEditComp = lazyPage(pages, 'DiscountEditHost');

const discountsRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'pricing/discounts',
  component: discountsComp,
  staticData: { title: 'Discounts' },
});

const discountCreateRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'pricing/discounts/create',
  component: discountCreateComp,
  staticData: { title: 'Create Discount' },
});

const discountEditRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'pricing/discounts/edit/$id',
  component: discountEditComp,
  staticData: { title: 'Edit Discount' },
});

/** Discounts sub-group of the pricing family. */
export const discountsLeaves = [discountsRoute, discountCreateRoute, discountEditRoute];
